import { isFromChapsPayment, isPaymentFlow } from '../../payees/states/addPayee/selectors';
import { getPaymentTypeOrPayeeType } from '../modes/selectors';

export const INIT_VALIDATION = 'INIT_VALIDATION';
export const INIT_BACS_VALIDATION = 'INIT_BACS_VALIDATION';

export const UPDATE_VALIDATION = 'UPDATE_VALIDATION';
export const HIDE_ERROR_MSG = 'HIDE_ERROR_MSG';
export const SHOW_ALL_ERRORS = 'SHOW_ALL_ERRORS';
export const INIT_VALIDATION_FOR_TEMPLATE = 'INIT_VALIDATION_FOR_TEMPLATE';
export const INIT_VALIDATION_FOR_IFT_PAYMENT_DETAILS = 'INIT_VALIDATION_FOR_IFT_PAYMENT_DETAILS';

export const SET_TYPE = 'SET_TYPE';
export const REMOVE_KEY = 'REMOVE_KEY';
export const ADD_VALIDATION_KEY = 'ADD_VALIDATION_KEY';
export const INIT_VALIDATION_FOR_ADD_PAYEE = 'INIT_VALIDATION_FOR_ADD_PAYEE';
export const INIT_VALIDATION_FOR_EDIT_PAYEE = 'INIT_VALIDATION_FOR_EDIT_PAYEE';
export const INIT_VALIDATION_FOR_EDIT_PAYEE_CHAPS = 'INIT_VALIDATION_FOR_EDIT_PAYEE_CHAPS';
export const DELETE_VALIDATION_FIELD = 'DELETE_VALIDATION_FIELD';
export const INIT_VALIDATION_FOR_ADD_INTERNATIONAL_PAYEE = 'INIT_VALIDATION_FOR_ADD_INTERNATIONAL_PAYEE';

export const initValidation = ({ id, templateMode }) => ({
	type: INIT_VALIDATION,
	id,
	templateMode,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const initBacsValidation = () => ({
	type: INIT_BACS_VALIDATION,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updateValidation = ({
	id,
	key,
	isValid,
	isFocusOn = false,
	isBackEndError = false,
	showValidation = false,
}) => ({
	type: UPDATE_VALIDATION,
	id,
	key,
	isValid,
	isFocusOn,
	isBackEndError,
	showValidation,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const hideErrorMsg = ({ id, key }) => ({
	type: HIDE_ERROR_MSG,
	id,
	key,
});

export const showAllErrors = (id) => ({
	type: SHOW_ALL_ERRORS,
	id,
});

export const initValidationForTemplate = () => ({
	type: INIT_VALIDATION_FOR_TEMPLATE,
});

export const setValidationType = ({ paymentType }) => ({
	type: SET_TYPE,
	paymentType,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const removeKey = ({ id }) => ({
	type: REMOVE_KEY,
	id,
});

export const addValidationKey = (key, value) => ({
	type: ADD_VALIDATION_KEY,
	key,
	value,
});

export const initValidationForAddPayee = () => (dispatch, getState) => {
	const state = getState();
	return dispatch({
		type: INIT_VALIDATION_FOR_ADD_PAYEE,
		isPaymentFlow: isPaymentFlow(state),
		isFromChapsPayment: isFromChapsPayment(getPaymentTypeOrPayeeType(state)),
	});
};
export const initValidationIFTPaymentDetails = () => ({
	type: INIT_VALIDATION_FOR_IFT_PAYMENT_DETAILS,
});

export const initValidationForEditPayee = (id, payeeDetails) => ({
	type: INIT_VALIDATION_FOR_EDIT_PAYEE,
	payeeDetails,
	id,
});

export const initValidationForEditPayeeChaps = (id, payeeDetails) => ({
	type: INIT_VALIDATION_FOR_EDIT_PAYEE_CHAPS,
	payeeDetails,
	id,
});

export const initValidationForAddInternationalPayee = (isPaymentFlow) => ({
	type: INIT_VALIDATION_FOR_ADD_INTERNATIONAL_PAYEE,
	isPaymentFlow,
});

export const deleteValidationField = (id, fieldId) => ({
	type: DELETE_VALIDATION_FIELD,
	id,
	fieldId,
});
